import { useState, Dispatch, SetStateAction, createContext, useContext } from 'react';
import { Plan } from '../@types/Billing/Plan';

export interface Props {
    children: React.ReactNode | React.ReactNode[];
}

export enum eBillingStep {
    ACCOUNT,
    PLAN,
    CREATE_CUSTOMER,
    PAYMENT,
    FINISHED_ALL
}

export interface IBillingContext {
    step: eBillingStep;
    setStep: Dispatch<SetStateAction<eBillingStep>>;
    selectedPlan: Plan;
    setSelectedPlan: Dispatch<SetStateAction<Plan>>;
}

export const BillingContext = createContext<IBillingContext>({} as IBillingContext);

export const BillingProvider = ({ children }: Props) => {
    const [step, setStep] = useState<eBillingStep>(eBillingStep.PLAN);
    const [selectedPlan, setSelectedPlan] = useState<Plan>({} as Plan);

    return (
        <BillingContext.Provider value={{ step, setStep, selectedPlan, setSelectedPlan }}>
            {children}
        </BillingContext.Provider>
    )
}

export default function useBillingContext() {
    const context = useContext(BillingContext);

    if (!context) {
        throw new Error("useBillingContext must be used within an App");
    }

    return context;
}